import { render, staticRenderFns } from "./baseDataBrand.vue?vue&type=template&id=e8772016&scoped=true&"
import script from "./baseDataBrand.vue?vue&type=script&lang=js&"
export * from "./baseDataBrand.vue?vue&type=script&lang=js&"
import style0 from "./baseDataBrand.vue?vue&type=style&index=0&id=e8772016&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8772016",
  null
  
)

export default component.exports